import Text from 'components/base/Text';
import React from 'react';
import LogoWithDudeWrapper from './LogoWithDudeWrapper';

export const InvitationExpiredView = () => (
  <LogoWithDudeWrapper dataCy='invitation-expired'>
    <Text size='x-x-x-large' pt='8rem' weight='300'>
      Just missed it...
    </Text>
    <Text size='large' pt='3rem' weight='400' align='center'>
      We are sorry, but your invitation has been expired. Please contact your
      LinearB admin and ask for a new invitation.
    </Text>
  </LogoWithDudeWrapper>
);
